export const nav = () => {
    $(document).ready(function () {
        // Nav active link handling
            var current = location.pathname;
            $('.menuItems a').each(function () {
                var $this = $(this);
                if (window.location.pathname.length <= 1) {
                } else if ($this.attr('href').indexOf(current) !== -1) {
                    $this.find(".active").addClass('nav-visited');
                }
            })

        // Active link handling for dropdown parent link
            var $current = location.pathname;
            $('.menuItems li > h5').each(function () {
                var $substring = $current.split("/");
                var $this = $(this);
                if (window.location.pathname.length <= 1) {
                } else if ($this.attr('value') == $substring[$substring.length - 2]) {
                    $this.addClass('nav-visited');
                } else if ($this.attr('value') == $substring[1]) {
                    $this.addClass('nav-visited');
                }
            })

        // Nav active links for dropdown child links
            var $current = location.pathname;
            $('.dropdown a, #attorneysSubMenu a').each(function () {
                var $this = $(this);
                var $substring = $current.split("/");
                if (window.location.pathname.length <= 1) {
                } else if (($this.attr('href').indexOf($current) !== -1) && ($substring[2] == undefined)) {
                    console.log("substring === ")
                    $this.find(".index").addClass('nav-visited');
                } else if ($this.attr('href').indexOf($current) !== -1) {
                    console.log($this);
                    $this.find("h5").addClass('nav-visited');
                    $this.prev("h5").addClass('nav-visited');
                }
            })

        // Dropdown menus
        // Add hover to dropdown parent links
            $(".parent").hover(
                function () {
                    $(this).children('.collapse').collapse('show');
                    $(this).children('h5:first').addClass('hovered');
                }, function () {
                    $(this).children('.collapse').collapse('hide');
                    $(this).children('h5:first').removeClass('hovered');
                }
            )

            // OPEN AND CLOSE MOBILE MENU
            $('.hamburger').click(function (e) {
                e.preventDefault();
                var $this = $(this);
                var $menu = $("#mobileMenu");
                $this.toggleClass('is-active');
                if ($this.hasClass("is-active")) {
                    $menu.removeClass("slideOutLeft");
                    $menu.show();
                    $menu.addClass("slideInLeft");
                    $('body').css('overflow', 'hidden')
                } else {
                    $menu.removeClass("slideInLeft");
                    $menu.addClass("slideOutLeft");
                    $('body').css('overflow', 'inherit');
                }
            });
    });
}
